import React, { Component } from 'react';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import CardStatus from '../CardStatus';

import { COLORS, commonStyles } from '../../styles/styles';

import iconWebinar from '../../assets/icon_webinar_b.png';
import iconCalendarX from '../../assets/icon_calendarX_b.png';
import iconCalendar from '../../assets/icon_calendar_b.svg';

import Button from '@material-ui/core/Button';
import * as moment from 'moment';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import ScaleLoader from 'react-spinners/ScaleLoader';

import {
  MDBBtn, 
  MDBCard, 
  MDBCardBody, 
  MDBRotatingCard,
  MDBCardImage,
  MDBCardTitle, 
  MDBCardText, 
  MDBRow, 
  MDBCol, 
  MDBIcon, 
  MDBBadge, 
  MDBContainer,
  MDBCollapseHeader,
  MDBCollapse
} from "mdbreact";
import placeHolder from '../../assets/placeholder.png'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Countdown from 'react-countdown';
import { STORAGE_LINK } from '../../constants';


export const checkOverdue = dueDate => {
  // if(content.type!=='Assignments'){
  //   return false;
  // }else{
    return moment(dueDate).isBefore(moment().add(-1,'days'));
  //}
 
};


var att = 0


class WebinarCard extends Component {
  state = { totalHeight:300}

  constructor(props){
    super(props)
    this.myDiv = React.createRef()
    
  }

  componentDidMount(){
    //let { clientHeight, clientWidth } = this.refs.myImgContainer;
    // 
    // 
    // this.setState({totalHeight:this.myDiv.current.clientHeight})
    
  }

  renderer = ({ days, hours, minutes, seconds, completed }) => {
  
   if (completed) {
      // Render a completed state
      return <div><MDBBtn className="assessmentBtn" size="sm" color="success"  onClick = {() => {this.props.handleOpen(this.props.content)}}>
      Join
      </MDBBtn></div>;
    } else {
      // Render a countdown
      return <div><div style={{fontFamily:'GothamBlack', marginTop:30, marginBottom:30}}>{days}days {hours}h {minutes}m {seconds}s</div></div>;
    }
  };

  flipCard() {
   
    try {
      
      this.setState({totalHeight:this.myDiv.current.clientHeight})
      this.props.flipIt(true);
    } catch (error) {
      
    }
  }

  flipCardAgain() {
   
    try {
      
      this.setState({totalHeight:this.myDiv.current.clientHeight})
      this.props.flipIt(false);
    } catch (error) {
      
    }
  
  }

  
  
  render() {

const { classes,
isSelected,
content,
isTransparent,
backgroundImg,
type,
name,
due_date,
start_date,
moduleName,
handleExtensionRequest,
handleResubRequest,
handleExpandClick,
handleOpen,
handleManager,
handleAlert,
description,
contentId,
onThinkToolClick,
status,
messageCount,
handleView,
attempts,
isExpanded,
showAlert,
toggleCollapse,
collapseID, 
flipped1, 
flipCard,
handleImageLoaded,
imageLoadedNow } = this.props;

return (
  

  
  <div style={{position:'relative'}}>

  <MDBCard cascade className='face front z-depth-2 mb-2'>
     
        <div style={{position:'relative'}}>
          <div className="compImg">
            <img src={STORAGE_LINK+backgroundImg} className="z-depth-0 rounded-corners" style={{padding: 10, width:'100%'}} alt="" onLoad={handleImageLoaded} />
           
          </div>
          <div className="compPill">
            <CardStatus className="white-text" status={status}/>
          </div>
        
          {/* <div  style={{position:'absolute', bottom:40, zIndex:2}}>
            <div className='xs-copy text-white uppercase-text text-left pt-3 pl-3'>
              {moduleName}
            </div>
            <h6 className='text-white text-left pl-3 pb-2'>
              {name}
            </h6>
          </div>
          <div>
            <img src={placeHolder} className="z-depth-0" style={{position:'sticky',top:0,left:0,padding: 0, width: '100%'}} alt=""/>
            <img src={STORAGE_LINK+backgroundImg} className="z-depth-0" style={{position:'absolute',top:0,left:0,padding: 0, width: '100%'}} alt="" onLoad={handleImageLoaded} />
            <div style={{padding: 0, height: 'calc(100% - 40px)', width: '100%', position:'absolute', top:0, left:0}} className='background-gradient-main2'></div>
          </div> */}
          
            {/* <div className="xs-copy-ptsans" style={{width:'45%', float: 'left'}}>
              <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round"  color="grey-color">{attempts.length>1 ? att=0 :  att = 2-attempts.length}</MDBBadge> Attempts
            </div> */}
            {/* <MDBBtn
            style={{top: 4, boxShadow: 'none'}}
              floating
              tag='a'
              className='ml-auto ml-4 '
              action
              style={{marginBottom: '-10px'}}
              size="sm">
              <MDBIcon icon='users' className="grey-color"/>
            </MDBBtn> */}

        </div>
        {/* <div style={{position:'absolute', right:10, top:10}}>
          <CardStatus className="white-text" status={status} />
        </div> */}
        <MDBCardBody style={{position:'relative',textAlign: 'center',padding: '0'}}>
          <div className="compIcon">
            <img src={iconWebinar} />
          </div>
          {((status=='not started' || status=='in progress' || status=='completed') && this.props.content.mediaUrl==null && moment(this.props.content.end_date)>moment()) ? 
          
          <Countdown date={due_date} renderer={this.renderer}/> : this.props.content.mediaUrl!=null ? <MDBBtn className="assessmentBtn" size="sm" color="success"  onClick = {() => {this.props.handleOpen(this.props.content)}}>
          VIEW SESSION
          </MDBBtn> : <div style={{marginTop:20}}>Session is over</div>
          }
      
          {showAlert && <Dialog
        open={showAlert}
        onClose={handleAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Resubmissions"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Please note that you are requested to pay for this resubmission attempt. Please refer to your learner support consultant for the fee and process to follow. You can view the resubmission request status in the ‘resubmissions for approval’ column. Your assessment will automatically become available in the “assessments available” column, with the new submission due date, once approved. 
          Thank you and good luck
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>  {
              handleResubRequest(content);
              handleAlert();
            }
          } color="primary">
            Ok
          </Button>
          <Button onClick={handleAlert} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>}
      <div className='grey lighten-2 pt-2 pl-2 pr-2 pb-1 grey-bar'>
            {(checkOverdue(due_date) && (status=='ready' || status=='not started' || status=='in progress')) ? 
              <div style={{width:'55%', float:'right', textAlign:'right'}}>
                <div style={{display:'inline-block', float:'right', margin:'4px 0 4px 0'}} className="xs-copy-popins">{start_date}</div>
              </div> 
              : 
              <div  style={{width:'55%', float:'right', textAlign:'right'}}>
                <div style={{display:'inline-block', float:'right', margin:'4px 0 4px 0'}} className="xs-copy-popins">{start_date}</div>
              </div>}
          </div>
        </MDBCardBody>
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{imageLoadedNow && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
        color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>

      </MDBCard>
    
      {}

     {flipped1 && <MDBCard style={{ position:'absolute', top:0, bottom:0, left:0, right:0, zIndex:3}}  className='face back z-depth-2'>
        <MDBCardBody style={{marginTop: 40, padding: 0}}>
        <div style={{position: 'absolute', top: 0,left:0, width: '100%'}}>
        <div style={{height:40, paddingTop: 5, borderBottom: '1px solid #DDDDDD', backgroundColor:'#eeeeee'}} className='pl-2 pr-2 pb-1' >
          <div className="xs-copy-ptsans" style={{width:'55%', float: 'left'}}>
              <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round"  color="grey-color">{attempts.length}</MDBBadge> Past Attempts
          </div>
          <div onClick={()=>flipCard()} className="xs-copy-ptsans" style={{width:'35%', float: 'right', textAlign:'right', zIndex:10000}}>
            <MDBIcon style={{marginRight: 5, fontSize:18, marginTop:4}} className="dark-grey-text" icon='times'/>
          </div>
        </div>
        </div>
        {attempts && attempts.map(item => (
          <div style={{backgroundColor: '#ffffff'}} key={item.attempt}>
            <div style={{height:45, paddingTop: 5, borderBottom: '1px solid #DDDDDD', position:'relative'}} className='grey lighten-2 pl-2 pr-2 pb-1' >
              {}
              <div className="xs-copy-ptsans" style={{display: 'inlineBlock', position: 'absolute', left: 10, top: 15}}>
                Attempt {item.attempt} {item.percentage}%
              </div>
              <div onClick={()=>handleView(content, item)} className="xs-copy-ptsans" style={{display: 'inlineBlock', position: 'absolute', right: 0, right: 5, top: 10}}>
              <MDBIcon style={{marginRight: 5, fontSize:24}} className="dark-grey-text" icon='search'/>
            </div>
            </div>
          </div>
        ))}
        
        </MDBCardBody>
      
      </MDBCard>}
     
    
    </div>
    
  
);
        }
      }

      WebinarCard.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  isTransparent: PropTypes.bool,
  backgroundImg: PropTypes.string,
  type: PropTypes.string,
  messageCount: PropTypes.number,
  name: PropTypes.string,
  handleExtensionRequest: PropTypes.func,
  handleView: PropTypes.func,
  handleOpen: PropTypes.func,
  handleSubmit: PropTypes.func,
  dueDate: PropTypes.string,
  startDate: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  contentId: PropTypes.number,
  onThinkToolClick: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
  expandBar:{
    backgroundColor: '#323232',
    height:'5px'
  },
  card: {
    borderRadius: 0,
    justifyContent: 'space-between',
    height: '100%',
    minHeight:280,
    backgroundSize: 'cover',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    backgroundColor: COLORS.white,
    opacity: 1,
  },
  isTransparent: {
    opacity: 0.4,
  },
  selectedCard: {
    borderColor: COLORS.cornerstoneRed,
  },
  cardContent: {
    padding: 0,
    flex: 1,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  defaultButton: {
    backgroundColor: COLORS.lightGrey,
    color: '#000',
    fontFamily: 'Gotham-Black',
    boxShadow: 'none',
    boxSizing: 'border-box',
    height: 30,
    width:'100%',
    borderRadius: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '&:hover': {
      backgroundColor: COLORS.darkGrey,
      color: '#ffffff',
    },
    '&:active': {
      boxShadow: '0 1px 12px 7px rgba(0,0,0,0.5) inset',
    },
  },
  cardContentWrapper: {
    padding: 20,
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
  },
  fileWrapper: {
    backgroundColor: '#161616',
    height:92
  },
  cardIcon:{
    position: 'absolute',
    bottom: 15,
    right: 15,
    height: 50
  },
  cardTitle: {
    fontFamily: 'Gotham-Black',
    color: COLORS.darkGrey,
    fontSize: 16,
    lineHeight: '20px',
    marginBottom: 10,
  },
  itemLeft: {
    flex: 4,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    marginTop: 28,
    '&:focus': {
      outline: 'none',
    },
  },
  assessmentDescription: {
    color: COLORS.white,
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
    textShadow: '1px 1px 3px #000'
  },
  moduleName: {
    color: COLORS.white,
    fontFamily: 'Gotham-Black',
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  doneWrapper: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
});

export default compose(
  withState('isShowPopup', 'togglePopup', false),
  withState('isExpanded', 'toggleExpanded', false),
  withState('showAlert', 'toggleShowAlert', false),
  withState('flipped1', 'flipIt', false),
  withState('imageLoadedNow', 'toggleImageLoaded', true),
  withHandlers({
    onThinkToolClick: props => (event, contentId) => {
      const { openMessages, selectedContentHandler } = props;
      event.stopPropagation();
      openMessages(true);
      selectedContentHandler(contentId);
    },
    
    flipCard: props => () => {
      const { isExpanded, flipped1 } = props;
      props.flipIt(!flipped1);
    },
    handleAlert: props => () => {
      const { showAlert } = props;
      props.toggleShowAlert(!showAlert);
    },
    handleImageLoaded: props => () => {
      props.toggleImageLoaded(false)
    },
    handleOpenSession: props => () => {
     
    }
  }),
  lifecycle({
    
  }),
  withStyles(styles),
)(WebinarCard);
